import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/ProformaInvoice/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is a Proforma Invoice?
          </h2>
          <p className={cn('about__paragraph')}>
            It looks like a Commercial Invoice, but it functions differently. It’s issued by the seller to the
            buyer before the shipment takes place. It lists the specs, price, Incoterms, and delivery
            timeline. The key difference? It’s not a demand for payment. It’s a "good faith" estimate. It
            says, "If you buy this, here is exactly what it will cost and how we will ship it."
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href="/download/Resources/FreightTemplates/proforma_invoice.doc"
              target='_blank'
            >
              Download (Word)
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href="/download/Resources/FreightTemplates/proforma_invoice.pdf"
              target='_blank'
            >
              Download (pdf)
            </a>
          </div>
        </div>

        {/* TODO: uncomment when picture is provided */}
        {/* <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div> */}

      </div>
    </section>
  );
};

export default SectionAbout;